import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-detail-view-container',
    templateUrl: './detail-view-container.component.html',
    styleUrls: ['./detail-view-container.component.scss'],
    standalone: false,
})
export class DetailViewContainerComponent {
}
